import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'PowerUsageCache';

/**
 * Holds power usage summaries keyed by rk (1 rk = 1 period).
 */
class PowerUsageCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Summaries sorted by period start, oldest first.
     * @returns {object[]}
     */
    getAll = () => {
        try {
            return [...this._items].sort((a, b) => a.start - b.start);
        } catch (error) {
            this.logError('getAll', error.message);
            return [];
        }
    };

    /**
     * Summary with the most recent period start.
     * @returns {object|null}
     */
    getLatest = () => {
        try {
            return this._items.reduce((latest, s) => (!latest || s.start > latest.start ? s : latest), null);
        } catch (error) {
            this.logError('getLatest', error.message);
            return null;
        }
    };

    /**
     * Full replace — used by REST fetch, which returns the complete set.
     * @param {object[]} items
     */
    replaceAll = (items) => {
        try {
            this._items = [];
            this.addOrUpdate(items);
        } catch (error) {
            this.logError('replaceAll', error.message);
        }
    };
}

const powerUsageCache = new PowerUsageCache();
export default powerUsageCache;
